import Axios from '../Axios';
import config from '../../config';

const { api } = config;

export default class PharmacyNoteConfigsApi {
    static getToken() {
        return window.localStorage.getItem('token');
    }

    static getByPharmacyId(pharmacyId) {
        const token = this.getToken();
        return Axios({
            url: `${api.baseUrl}/pharmacy-note-configs`,
            method: 'GET',
            params: { pharmacyId },
            headers: { Authorization: `Bearer ${token}` },
        });
    }
}
